<template>
  <div class="overlay-info">
    <div class="overlay-header hide-portrait" :class="{'active': hasBanner}"></div>
    <div class="overlay-content">
        <div class="overlay-info-header topbar-container drop-shadow">
            <Icon name="logo"></Icon>
            <h2 class="overlay-title">{{title}}</h2>
            <div class="flex-spacer"></div>
            <slot name="header-right">
                <button class="btn btn-close" @click="close()">
                    <label data-translation-element="close">Sulge</label>
                    <div class="circle"><Icon name="close"/></div>
                </button>
            </slot>
        </div>
        <div class="overlay-info-content">
            <slot/>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
		title: {
			type: String,
			default: ""
		},
    },
    computed: {
        hasBanner () {
            return false;
        }
    },
    methods: {
        close () {
            this.$emit("close");
        }
    }
}
</script>

<style lang="less">
    @import '../css/variables';
    @import '../css/responsive';

    .overlay-info {
        top: 100%;
        bottom: 0;
        position: absolute;
        overflow: hidden;
        flex-direction: column;
        width: 100%;   
        display: none;
        z-index: 3;
        transition: top 0.3s ease-out;

        &.active {
            top: 0 !important;
            display: flex;
        }
    }

    .overlay-info-container {
        height: 40vh;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .overlay-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .overlay-info-content {
        height: 100%;
        overflow: hidden;
        background-color: white;
    }

    .overlay-info-header {
        background-color: white;
        flex-basis: @top-bar-height !important;
        justify-content: space-evenly;
        flex-direction: row !important;
        align-items: center;
        z-index: 1;
        
        .icon-logo {
            --color1: rgba(52, 56, 71, 1);
            height: 2rem;
            margin-right: 1.6rem;
        }
    }

    .overlay-header {
        flex-basis: 35.5rem;
        flex-grow: 0;
        flex-shrink: 0;
        z-index: 0;

        opacity: 0;
        transition: opacity 0.3s ease-out;

        &.active {
            opacity: 1;
        }
    }

    .overlay-title {
        color: @active-color;
        font-size: 1.8rem;
    }

    .btn-close {
        display: flex;
        align-items: center;
        background-color: transparent !important;

        .circle {
            border: 0.2rem solid rgba(224, 223, 223, 1);
            border-radius: 50%;
            width: 3.2rem;
            height: 3.2rem;
            padding: 0.8rem;
            margin-left: 0.8rem,
            
        }
        .icon {
            height: 1.6rem !important;
            margin: auto;
        }
    }

    .overlay-header-poi {
        font-size: 1.4rem;
        font-weight: 500;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .icon {
            height: 1.4rem;
            margin-right: 0.8rem;
            --color1: #A7A9AC;
        }

        & > div {
            margin-left: 2.4rem;
        }
    }

    @media @portrait {
        .overlay-info {
            flex-direction: column;
        }

        .overlay-info-header {
            padding-left: 7.2rem;
            padding-right: 7.2rem;
        }

        .overlay-background {
            height: 34vh + 20vh !important;
        }

        .overlay-info-container {
            padding-bottom: 2.8rem;
        }

        .overlay-info-content {
            padding-bottom: 2.8rem;
        }
    }

    @media @landscape {
        .overlay-info {
            &.active {
                bottom: 8rem;
            }
            .overlay-info-container {
                width: 34%;
                right: 0;
                top: 0;
                height: 100%;
            }

            .overlay-info-header {
                padding-left: 2.4rem;
                padding-right: 2.4rem;
            }
        }
    }
</style>